const projects = [
  {
  id: "llm-basics",
  title: "LLM Fundamentals",
  description: "Interactive guide to tokens, context windows, and how system & user messages are bundled for continuous iteration",
  icon: "🧠",
  tags: ["React", "LLM", "Tokens", "Context Window"],
  path: "/llm-basics",
  },
  {
    id: "aws-ml-services-overview",
    title: "AWS ML Services Overview",
    description: "Overview of AWS AI and ML services including Bedrock, SageMaker, and AI Services",
    icon: "🧠",
    tags: ["React", "AWS", "ML", "AI"],
    path: "/aws-ml-services-overview",
  },
  {
    id: "aws-vector-stores",
    title: "AWS Vector Stores",
    description: "Deep dive into AWS vector store options for Bedrock Knowledge Bases",
    icon: "🗄️",
    tags: ["React", "AWS", "Bedrock", "Vector Stores"],
    path: "/aws-vector-stores",
  },
  {
    id: "chunking-strategies",
    title: "Chunking Strategies",
    description: "Deep dive into chunking strategies for Bedrock Knowledge Bases",
    icon: "✂️",
    tags: ["React", "AWS", "Bedrock", "RAG"],
    path: "/chunking-strategies",
  },
  {
    id: "multi-agent-explorer",
    title: "Multi-Agent Architecture",
    description: "Interactive visualization of LLM agents, tools, memory, and multi-agent patterns",
    icon: "🤖",
    tags: ["React", "Tailwind", "LLM", "AI Agents"],
    path: "/multi-agent-explorer",
  },
  {
    id: "bedrock-agents",
    title: "AWS Bedrock Agents",
    description: "Deep dive into AWS Bedrock Agent architecture, action groups, and real-world use cases",
    icon: "☁️",
    tags: ["React", "AWS", "Bedrock", "Agents"],
    path: "/bedrock-agents",
  },
  {
  id: "bedrock-rag",
  title: "AWS Bedrock RAG",
  description: "Deep dive into AWS Bedrock RAG approaches, chunking, embedding, and vector stores",
  icon: "📚",
  tags: ["React", "AWS", "Bedrock", "RAG"],
  path: "/bedrock-rag",
  },
  {
  id: "token-efficiency",
  title: "Token Efficiency",
  description: "Deep dive into token efficiency strategies for AWS Bedrock",
  icon: "🪙",
  tags: ["React", "AWS", "Bedrock", "Tokens"],
  path: "/token-efficiency",
  },
  {
  id: "sagemaker-inference",
  title: "AWS SageMaker Inference",
  description: "Deep dive into AWS SageMaker Inference options, payloads, and use cases",
  icon: "🔬",
  tags: ["React", "AWS", "SageMaker", "Inference"],
  path: "/sagemaker-inference",
  },
  {
  id: "bedrock-inference",
  title: "AWS Bedrock Inference",
  description: "Deep dive into AWS Bedrock Inference options, payloads, and use cases",
  icon: "🧠",
  tags: ["React", "AWS", "Bedrock", "Inference"],
  path: "/bedrock-inference",
  },
  {
  id: "bedrock-rerank-hybrid-search",
  title: "AWS Bedrock Rerank & Hybrid Search",
  description: "Deep dive into AWS Bedrock Rerank and Hybrid Search approaches",
  icon: "🔍",
  tags: ["React", "AWS", "Bedrock", "RAG"],
  path: "/bedrock-rerank-hybrid-search",
  },
  {
  id: "Strands Agent and Agent Squad",
  title: "Strands Agent and Agent Squad",
  description: "Deep dive into Strands Agent SDK and Agent Squad coordination framework",
  icon: "🧩",
  tags: ["React", "Strands", "Agents", "Squad"],
  path: "/strands-agent-squad",
  },
  {
  id: "mcp-server-a-architecture",
  title: "MCP Server Architecture",
  description: "Deep dive into the architecture of MCP servers and how they integrate with LLMs",
  icon: "🔌",
  tags: ["React", "MCP", "LLM", "Architecture"],
  path: "/mcp-server-a-architecture",
  },
  {
  id: "bedrock-guardrails",
  title: "AWS Bedrock Guardrails",
  description: "Deep dive into AWS Bedrock Guardrails monitoring and configuration",
  icon: "🛡️",
  tags: ["React", "AWS", "Bedrock", "Guardrails"],
  path: "/bedrock-guardrails",
  },
  {
  id: "prompt-types",
  title: "Prompt Types",
  description: "Deep dive into prompt types and best practices for AWS Bedrock",
  icon: "✍️",
  tags: ["React", "AWS", "Bedrock", "Prompt Engineering"],
  path: "/prompt-types",
  },
  {
  id: "LLM-Training-And-FineTuning",
  title: "LLM Training and Fine-Tuning",
  description: "Deep dive into LLM training and fine-tuning techniques for AWS Bedrock",
  icon: "🎓",
  tags: ["React", "AWS", "Bedrock", "LLM Training"],
  path: "/llm-training-and-finetuning",
  },
  {
  id: "sagemaker-lineage",
  title: "SageMaker Lineage & Bedrock Eval",
  description: "ML lineage tracking & Bedrock model evaluation — provenance, metrics, and quality assessment",
  icon: "🔗",
  tags: ["React", "AWS", "SageMaker", "Bedrock", "MLOps"],
  path: "/sagemaker-lineage",
  },
  {
  id: "useful-architectures",
  title: "Useful AWS Architectures",
  description: "Production-ready reference architectures for ML data ingestion, vector search, and more",
  icon: "🏗️",
  tags: ["React", "AWS", "Architecture", "OpenSearch"],
  path: "/useful-architectures",
  },
  {
  id: "Glue-Crawlers-And-Data-Catalog",
  title: "Glue Crawlers and Data Catalog",
  description: "Deep dive into AWS Glue Crawlers and Data Catalog — how they work together to make S3 data queryable",
  icon: "📊",
  tags: ["React", "AWS", "Glue", "Data Catalog"],
  path: "/glue-crawlers-and-data-catalog",
  },
  {
  id: "karpathy-gpt",
  title: "GPT in 243 Lines — Karpathy",
  description: "Interactive walkthrough of Andrej Karpathy's nanoGPT — animated architecture, attention explorer, and training dynamics",
  icon: "🔬",
  tags: ["React", "GPT", "Transformers", "Karpathy", "Deep Learning"],
  path: "/karpathy-gpt",
  }

];

export default projects;
